import React from 'react';
import { Box, Text } from '@cubeyou-team/hx-react-components';

const SearchResultsCounter = ({ count }) => (
  <Box pX="small">
    <Box pY="medium" borderSize="2px" borderPosition="bottom">
      <Box pX="small">
        <Text size="xbody" lettercase="capitalize">
          Results ({count})
        </Text>
      </Box>
    </Box>
  </Box>
);

export default SearchResultsCounter;
